import api from "@/services/api.ts";
import {CreatePreferenceDto, Preference} from "@/types/Preference.ts";

const URL = '/mentee-preferences';

// Create Preference
export const createPreference = async (preference: CreatePreferenceDto): Promise<CreatePreferenceDto> => {
    try{
        const response = await api.post(URL, preference);
        return response.data;
    } catch (error) {
        throw new Error('Failed to create preference');
    }
}

export const getPreferenceByMenteeId = async (menteeId: number): Promise<Preference | null> => {
    try {
        const response = await api.get(`${URL}/${menteeId}`);
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.status === 404) {
            return null;
        }
        throw error;
    }
};

export const getPreferences = async (seasonId?: number): Promise<Preference[]> => {
    const suffix = seasonId ? `?seasonId=${seasonId}` : "";
    const response = await api.get<Preference[]>(`${URL}${suffix}`);
    return response.data;
};

export const getPreferenceCount = async (): Promise<number> => {
    const response = await api.get<number>(`${URL}/count`);
    return response.data;
};

// Update preference
export const updatePreference = async (id: number, preference: CreatePreferenceDto): Promise<Preference> => {
    try {
        const response = await api.put(`${URL}/${id}`, preference);
        return response.data;
    } catch (error) {
        throw new Error('Failed to update preference');
    }
}

export const deletePreference = async (id: number): Promise<void> => {
    try{
        await api.delete(`${URL}/${id}`);
    } catch (error) {
        throw new Error('Failed to delete preference.');
    }
};
